import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { CloseIcon, ChevronLeftIcon } from 'ui-component/custom-icons/icons';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';

import PdfViewer from 'ui-component/PdfViewer';
import { motion, AnimatePresence } from 'framer-motion';
import { Skeleton, Avatar, Tooltip } from '@mui/material';

const InvoiceAttachmentModal = ({ id, openPopup, handleClose }) => {
    const [showPreviewDocument, setShowPreviewDocument] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [dataList, setDataList] = useState([]);
    const [attachmentUrl, setAttachmentUrl] = useState('');
    const [attachmentFileName, setAttachmentFileName] = useState('');

    useEffect(() => {
        initializeData()
    }, []);
    
    const initializeData = () => {

        setIsLoading(true);
        api.getInvoiceAttachmentById(id).then((res) => {
            setIsLoading(false);
            if (res?.status) {
                setDataList(res?.data?.data?.attachments || []);
                setInvoiceNumber(res?.data?.data?.invoice_number || '');
            }
        });
    }


    const variants = {
        enter: { x: 50, opacity: 0 },
        center: { x: 0, opacity: 1 },
        exit: { x: -50, opacity: 0, position: 'absolute' } // Absolute prevents layout jumping
    };

    return (
        <Modal show={openPopup} centered size="md" onHide={handleClose}>
            {/* FIX: Added a relative container with a fixed min-height 
               to keep the modal size stable during the switch.
            */}
            <Modal.Body style={{ 
                overflow: 'hidden', 
                position: 'relative', 
                minHeight: '230px', 
                padding: '20px' 
            }}>
                <AnimatePresence mode="wait">
                    {showPreviewDocument ? (
                        /* --- PREVIEW VIEW --- */
                        <motion.div
                            key="preview"
                            variants={variants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            transition={{ duration: 0.25, ease: "easeInOut" }}
                            style={{ width: '100%' }}
                        >
                            <div className="mb-2 flex justify-content-between align-items-center">
                                <button
                                    className="btn modal-back-icon"
                                    onClick={() => {
                                        setShowPreviewDocument(false)
                                        setAttachmentUrl('');
                                        setAttachmentFileName('');
                                    }}
                                >
                                    <ChevronLeftIcon height={'16px'} width={'16px'} />
                                </button>
                                <button className="btn modal-close-icon" onClick={handleClose}>
                                    <CloseIcon height={'16px'} width={'16px'} />
                                </button>
                            </div>

                            <div className="text-center mb-3">
                                <div style={{ fontSize: '18px', fontWeight: '500' }}>
                                    {attachmentFileName}
                                </div>
                            </div>

                            <div className="border rounded" style={{ overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                {/* <PdfViewer src={'http://localhost:8000/storage/uploads/estimation/attachments/214/JOY SONG.pdf#toolbar=0&navpanes=0&zoom=FitW'} /> */}
                                <PdfViewer src={attachmentUrl+'#toolbar=0&navpanes=0&zoom=FitW'} />
                            </div>

                            <div className="mt-4 flex justify-content-end gap-2">
                                <a
                                    href={attachmentUrl}
                                    className="btn btn-primary btn-outlined-main-primary btn-create-report"
                                    target="_blank"
                                >
                                    Download
                                </a>
                                <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main">Close</button>
                            </div>
                        </motion.div>
                    ) : (
                        /* --- LIST VIEW --- */
                        <motion.div
                            key="list"
                            variants={variants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            transition={{ duration: 0.25, ease: "easeInOut" }}
                            style={{ width: '100%' }}
                        >
                            <div className="mb-2 flex justify-content-end">
                                <button className="btn modal-close-icon" onClick={handleClose}>
                                    <CloseIcon height={'16px'} width={'16px'} />
                                </button>
                            </div>

                            <div className="text-center mb-4">
                                <div style={{ fontSize: '20px', fontWeight: '600' }}>Attachments</div>
                                    <div className='text-muted' style={{ fontSize: '13px' }}>
                                        {
                                            isLoading ? (
                                                <div>
                                                    <Skeleton variant="text" width={300} height={30} className="mx-auto" />
                                                </div>
                                            ) : (
                                                `List of attachments from Invoice ${invoiceNumber}`
                                            )
                                        }
                                    
                                </div>
                            </div>

                            {
                                isLoading ? (
                                        
                                    [...Array(2)].map((e, i) => (
                                        <div 
                                            className="bg-white border rounded p-3 mb-2 hover-shadow" 
                                            style={{ transition: 'all 0.2s', border: '1px solid #eee', cursor: 'not-allowed' }}
                                        >
                                            <div className="flex align-items-center justify-content-between">
                                                <div className="flex align-items-center" style={{ gap: '12px' }}>
                                                    <div>
                                                        <Skeleton variant="rounded" width={30} height={30} className="mx-auto" />
                                                    </div>
                                                        
                                                    <div>
                                                        <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                                                            <Skeleton variant="rounded" width={200} height={15} className="mx-auto" />
                                                        </div>
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>
                                                            <Skeleton variant="rounded" width={50} height={15} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ transform: 'rotate(180deg)', opacity: 0.5 }}>
                                                    <ChevronLeftIcon height={'14px'} width={'14px'} />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    dataList?.length < 1 ? (
                                        <div className="text-center text-muted py-5">
                                            No attachments found.
                                        </div>
                                    ) : (
                                        dataList?.map((item, index) => {
                                            return (

                                                <div 
                                                    className="bg-white border rounded p-3 mb-2 cursor-pointer hover-shadow"
                                                    style={{ transition: 'all 0.2s', border: '1px solid #eee' }}
                                                    onClick={() => {
                                                        setShowPreviewDocument(true)
                                                        setAttachmentUrl(item?.attachment_url);
                                                        setAttachmentFileName(item?.filename);
                                                    }}
                                                >
                                                    <div className="flex align-items-center justify-content-between">
                                                        <div className="flex align-items-center" style={{ gap: '12px' }}>
                                                            {
                                                                item?.extension !== 'pdf' ? (
                                                                    <InsertPhotoOutlinedIcon style={{ fontSize: 24, color: '#0067ff' }} />
                                                                ): (
                                                                    <PictureAsPdfOutlinedIcon style={{ fontSize: 28, color: '#f44336' }} />
                                                                )
                                                            }
                                                            <div>
                                                                <div style={{ fontWeight: '500' }}>{item?.filename ?? 'File not available'}</div>
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>{item?.file_size ?? 'File size not available'}</div>
                                                            </div>
                                                        </div>
                                                        <div style={{ transform: 'rotate(180deg)', opacity: 0.5 }}>
                                                            <ChevronLeftIcon height={'14px'} width={'14px'} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )  
                                        })
                                     )    
                                )
                            }
                                


                            <div className="mt-4 flex justify-content-end">
                                <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main">Close</button>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </Modal.Body>
        </Modal>
    );
};

export default InvoiceAttachmentModal;